import { Link, useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
// import 'bootstrap/dist/css/bootstrap.min.css';
import SweetAlert from "react-bootstrap-sweetalert";
import { Button } from "react-bootstrap";
import Navmain from './header';
// import Navmain from '../components/landingpage/navbar';
import axios from "axios";
import Footer from './footer';
import GetQuoteForm from "./GetQuote";
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS


import Image1 from '../images/a1.webp'
import Image2 from '../images/a2.webp'
import Image3 from '../images/a3.webp'


function Home() {
  const navigate = useNavigate();
  const [allcats, setAllcats] = useState([]);
  const [user, setUser] = useState([]);
  const [alert1, setAlert1] = useState();
  const [uid, setUid] = useState();
  const [lead, setLead] = useState([]);
  const [promotion, setPromotion] = useState([]);
  const [searched, setSearched] = useState([]);
  const [trending, setTrending] = useState([]);
  const [trade, setTrade] = useState([]);
  const [city, setCity] = useState("Karachi");
  const [listcities, setCitiesList] = useState([]);

  const [main, setMainCat] = useState([]);
  const [error, seterror] = useState(false);
  const [cat, setCat] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [backgroundImage, setBackgroundImage] = useState(Image1);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [animationClass, setAnimationClass] = useState('');

  useEffect(() => {
    // getCities();
    getServercats()
    lead_view_all()
    Viewpromotion()
    ViewSearched()
    ViewTrending()
    Tradeshow()
    getMainCat()
    // const aa = localStorage.getItem("USER");



    const search = window.location.search;
    const params = new URLSearchParams(search);

    const spplier = params.get("name");

    ShowData(spplier);
    ShowBuyLeads();

    const aa = localStorage.getItem("USER");
    if (aa != null) {
      const as = JSON.parse(aa);
      setUid(as[0].id);
      setUser(as);
    }
  }, []);

  const dummyCategories = [
    { icon: "fa-bolt", title: "Electronics & Electrical" },
    { icon: "fa-industry", title: "Industrial Supplies" },
    { icon: "fa-building", title: "Building Construction" },
    { icon: "fa-capsules", title: "Drugs & Pharmaceuticals" },
    { icon: "fa-hospital", title: "Hospital & Diagnostics" },
    { icon: "fa-tshirt", title: "Apparel & Garments" },
    { icon: "fa-shopping-bag", title: "Food & Beverages" },
    { icon: "fa-building", title: "Industrial Plants & Machinery" }
  ];
  
  const categoriesToShow = Array.isArray(allcats) && allcats.length > 0 ? allcats.slice(0, 8) : dummyCategories;
  


  function isNotFloatOrAlpha(value) {
    // Check if value is a float
    const isFloat = typeof value === 'number' && !Number.isInteger(value);

    // Check if value is an alphabetical letter
    const isAlpha = typeof value === 'string' && /^[a-zA-Z]$/.test(value);

    // Return true if neither condition is true
    return !isFloat && !isAlpha;
  }
  

  const [errors, setErrors] = useState({}); // Initialize error object

  const validateFields = () => {
    let fieldErrors = {};
    if (!sheet[0].name) fieldErrors.name = "Error: Name of Product is required.";
    if (!sheet[0].qty || Number(sheet[0].qty) < 1) fieldErrors.qty = "Error: Quantity must be greater than 0.";
    if (!sheet[0].piece) fieldErrors.piece = "Error: Please select a valid unit.";
    if (!cat) fieldErrors.category = "Error: Category is required.";
    if (!sheet[0].price || Number(sheet[0].price) < 1) fieldErrors.price = "Error: Approx Price must be greater than 0.";
    if (!sheet[0].des) fieldErrors.des = "Error: Requirement Description is required.";
  
    setErrors(fieldErrors);
    return Object.keys(fieldErrors).length === 0; // Return true if no errors
  };
  
  const handleGetQuote = () => {
    if (validateFields()) {
      // If no errors, proceed to add the lead
      add_lead(sheet, uid, cat);
    }
  };





  const getMainCat = async () => {
    const data = new FormData();
    data.append('uid', 'ss');

    axios({
      method: 'post',
      url: '/pro/cat/maincat.php',
      data: data,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(s => {
        console.log('Main cat list ', s.data);
        const a = s.data;
        setMainCat(a);
        console.log("maincat news", s.data)
      })
      .catch(s => {
        console.log('here catch =>>', s);
      });
  };


  const [sheet, setSheet] = useState(
    [{
      id: 1,
      name: "",
      qty: "",
      quantity: "",
      piece: "Pieces",
      price: "",
      des: "",
      status: "normal",
      cat: ""
    }
    ]);

  const getServercats = async () => {
    const data = new FormData();

    data.append("uid", "");
    data.append("limit", "8");
    data.append("child_limit", "6");


    axios({
      method: "post",
      url: "/mainsite/cat_set_by_market.php",
      data: data,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((s) => {
        setAllcats(s.data);
      })
      .catch((s) => {
        // console.log("here catch =>>", s);
      });
  };

  const Viewpromotion = async () => {
    const data = new FormData();




    axios({
      method: "post",
      url: "/pro/promotional_products.php",
      data: data,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((s) => {
        console.log("Promotion", s.data)
        setPromotion(s.data);
      })
      .catch((s) => {
        // console.log("here catch =>>", s);
      });
  };


  const ViewSearched = async () => {
    const data = new FormData();
    axios({
      method: "post",
      url: "/pro/mostsearch.php",
      data: data,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((s) => {
        // console.log('searched', s.data);
        setSearched(s.data);
      })
      .catch((s) => {
        // console.log("here catch =>>", s);
      });
  };




  const ViewTrending = async () => {
    const data = new FormData();

    //data.append('array', JSON.stringify(profile));

    axios({
      method: "post",
      url: "/pro/trending.php",
      data: data,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((s) => {
        // console.log('trending', s.data);
        setTrending(s.data);
      })
      .catch((s) => {
        // console.log("here catch =>>", s);
      });
  };


  const Tradeshow = async () => {
    const data = new FormData();

    data.append("val", "last");


    axios({
      method: "post",
      url: "/pro/tradeshow/manage_trade.php",
      data: data,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((s) => {
        // console.log('tradeshow', s.data);
        setTrade(s.data);
      })
      .catch((s) => {
        // console.log("here catch =>>", s);
      });
  };


  const add_lead = async (sheet, uid, c) => {

    const data = new FormData();

    data.append("uid", uid);
    data.append("sheet", JSON.stringify(sheet));
    data.append("cat", c);
    data.append("img", "");

    axios({
      method: "post",
      url: "/pro/lead_add.php",
      data: data,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((s) => {

        setAlert1(!alert1);
        
        // Navigate to the new page and force a reload
        window.location.href = "/product-buy-request";
      })
      .catch((s) => {
        // console.log("here catch =>>", s);
      });

  };
  const lead_view_all = async id => {
    const data = new FormData();
    data.append('uid', id);

    axios({
      method: 'post',
      url: '/pro/lead_view_all.php',
      data: data,
      headers: { 'Content-Type': 'multipart/form-data' },
    })
      .then(s => {
        console.log('lead list ', s.data);
        const a = s.data;
        setLead(a);
      })
      .catch(s => {
        // console.log('here lead_view_all ', s);
      });
  };
  const changeArayquote = (i, changes) => {
    const oldArr = [...sheet];
    const oldObj = oldArr[i];
    oldArr[i] = { ...oldObj, ...changes };
    setSheet(oldArr);
  
    // Re-evaluate validation only for the changed field
    const validationErrors = { ...error }; // Preserve existing errors
  
    Object.keys(changes).forEach((key) => {
      if (key === "name" && !changes.name) {
        validationErrors.name = "Error: Name of Product is required.";
      } else if (key === "name") {
        delete validationErrors.name;
      }
  
      if (key === "qty" && (!changes.qty || Number(changes.qty) < 1)) {
        validationErrors.qty = "Error: Quantity must be greater than 0.";
      } else if (key === "qty") {
        delete validationErrors.qty;
      }
  
      if (key === "piece" && !changes.piece) {
        validationErrors.piece = "Error: Please select a valid unit.";
      } else if (key === "piece") {
        delete validationErrors.piece;
      }

      if (key === "category" && (!changes.category || changes.category == 'Select Main Category')) {
        validationErrors.category = "Error: Category is required.";
      } else if (key === "category") {
        delete validationErrors.category;
      }
  
      if (key === "price" && (!changes.price || Number(changes.price) < 1)) {
        validationErrors.price = "Error: Approx Price must be greater than 0.";
      } else if (key === "price") {
        delete validationErrors.price;
      }
  
      if (key === "des" && !changes.des) {
        validationErrors.des = "Error: Requirement Description is required.";
      } else if (key === "des") {
        delete validationErrors.des;
      }
    });
  
    seterror(validationErrors);
  };
  
  const [vendor, setVendor] = useState([])


  const ShowData = async (spplier) => {
    const data = new FormData();
    data.append("key", spplier);
    data.append("val", "supplier");
    axios({
      method: "post",
      url: "/pro/vender.php",
      data: data,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((s) => {

        console.log("Markets Data", s.data);
        setVendor(s.data)
      })
      .catch((s) => {
        // console.log("here catch =>>", s);
      });
  };

  const [buyLeads, setBuyLeads] = useState([])

  const ShowBuyLeads = async () => {
    const data = new FormData();
    axios({
      method: "post",
      url: "/pro/get_buy_leads.php",
      data: data,
      headers: { "Content-Type": "multipart/form-data" },
    })
      .then((s) => {
        setBuyLeads(s.data)
      })
      .catch((s) => {
        // console.log("here catch =>>", s);
      });
  };

  useEffect(() => {
    const carousel = document.getElementById('textCarousel');

    const handleSlide = (e) => {
      const nextIndex = e.to;
      const direction = nextIndex > currentIndex ? 'right' : 'left';
      setAnimationClass(`fade-${direction}`);
    
      let nextImage;
      switch (nextIndex) {
        case 0:
          nextImage = Image1;
          break;
        case 1:
          nextImage = Image2;
          break;
        case 2:
          nextImage = Image3;
          break;
        default:
          nextImage = Image1;
      }
    
      // Delay to match animation, then preload
      setTimeout(() => {
        const img = new Image();
        img.src = nextImage;
    
        img.onload = () => {
          setBackgroundImage(nextImage); // set only after image is loaded
          setCurrentIndex(nextIndex);
          setAnimationClass('');
        };
      }, 500);
    };
    

    carousel.addEventListener('slid.bs.carousel', handleSlide);

    return () => {
      carousel.removeEventListener('slid.bs.carousel', handleSlide);
    };
  }, [currentIndex]);


  return (
    <>
      <Navmain />
      <main className="main">
      <section className="pt-20 bg-home9 no-gutters px-md-4">
  <div className="container">
    <div className='row equal-height d-flex justify-content-between'>

    <div className="mb-3 col-lg-8 col-xl-9 d-flex flex-column align-items-stretch p-0">
  <div
    className="header-border-styles w-100"
    style={{
      boxShadow: "0px 0px 17px 6px #ccc",
      borderRadius: "16px",
      overflow: "hidden",
      backgroundColor: "#fff",
    }}
  >
    {/* Static Background Image with Carousel Text */}
    <div
      className={`main-image ${animationClass}`}
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        padding: "40px 20px",
        position: "relative",
        borderRadius: "16px 16px 0 0",
      }}
    >
      {/* Overlay */}
      <div
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: "rgba(0,0,0,0.4)",
          borderRadius: "16px 16px 0 0",
          zIndex: 1,
        }}
      ></div>

      {/* Carousel for Text */}
      <div
        id="textCarousel"
        className="carousel slide"
        data-bs-ride="carousel"
        style={{ position: "relative", zIndex: 2 }}
      >
        <div className="carousel-inner" style={{minHeight: "130px"}}>
          <div className="carousel-item active">
            <h5
              style={{
                fontWeight: "bold",
                color: "#fff",
                fontSize: "clamp(1.5rem, 3vw, 2.2rem)",
              }}
            >
              Connecting Wholesalers to Retailers across Pakistan
            </h5>
            <p style={{ color: "#f1f1f1", fontSize: "clamp(1rem, 2vw, 1.25rem)" }}>
              A leading digital marketplace made for wholesalers and retailers.
            </p>
          </div>
          <div className="carousel-item">
            <h5
              style={{
                fontWeight: "bold",
                color: "#fff",
                fontSize: "clamp(1.5rem, 3vw, 2.2rem)",
              }}
            >
              Alahdeen Your One-Stop Digital Solution for B2B
            </h5>
            <p style={{ color: "#f1f1f1", fontSize: "clamp(1rem, 2vw, 1.25rem)" }}>
              Simplifying B2B trade with a million+ products and trusted suppliers.
            </p>
          </div>
          <div className="carousel-item">
            <h5
              style={{
                fontWeight: "bold",
                color: "#fff",
                fontSize: "clamp(1.5rem, 3vw, 2.2rem)",
              }}
            >
              Digitizing Wholesale Across Pakistan with Seamless B2B
            </h5>
            <p style={{ color: "#f1f1f1", fontSize: "clamp(1rem, 2vw, 1.25rem)" }}>
              Helping wholesalers reach new markets online — instant solution.
            </p>
          </div>
        </div>
      </div>

      <div className="row g-3 mt-4" style={{ position: "relative", zIndex: 2 }}>
  {Array.isArray(categoriesToShow) &&
    categoriesToShow.slice(0, 8).map((category, index) => (
      <div key={index} className="col-6 col-sm-4 col-md-3">
        <div
          className="d-flex flex-column align-items-center justify-content-center"
          style={{
            backgroundColor: "rgba(255, 255, 255, 0.1)",
            borderRadius: "12px",
            height: "100px",
            cursor: "pointer",
            transition: "all 0.3s ease-in-out",
          }}
          onClick={(e) => {
            e.preventDefault();
            localStorage.setItem("title", category.title);
            window.location.assign("/sub/" + category.bread_crumbs);
          }}
        >
          <div style={{ fontSize: "32px", marginBottom: "4px", color: "#d1d5db" }}>
            <i className={`fas ${category.icon}`} />
          </div>
          <div
            style={{
              fontSize: "15px",
              fontWeight: "600",
              color: "#fff",
              textAlign: "center",
              lineHeight: "1.3",
            }}
          >
            {category.title}
          </div>
        </div>
      </div>
    ))}
</div>


      {/* View All */}
      <div className="text-left mt-3" style={{ position: "relative", zIndex: 2 }}>
        <Link to="/main">
          <span
            className="fw-normal"
            style={{ color: "#FD9636", fontSize: "16px" }}
          >
            View All Categories
          </span>
        </Link>
      </div>
    </div>
  </div>
</div>







      {/* Get Quote Form */}
      <div className="mb-3 col-lg-4 col-xl-3 order-last order-lg-last d-flex align-items-stretch p-0">
        <GetQuoteForm />
      </div>
    </div>
  </div>
</section>


<section className="bg-home9 no-gutters px-md-4">
  <div className="container">
    <div className="row">
      {(Array.isArray(allcats) ? allcats : []).map((v, i) => (
        <div key={i} className="col-12 mb-4 d-flex flex-column align-items-stretch p-0">
          <div
            style={{
              backgroundColor: '#ffffff',
              borderRadius: "16px 16px 0 0",
              boxShadow: '0px 0px 6px 2px #ccc',
              overflow: 'hidden',
              marginLeft: '5px',
              marginRight: '5px'
            }}
          >
            {/* 🔷 Title + Image + See All */}
            <div
              className="d-flex justify-content-between align-items-center px-4 pb-3"
              style={{ backgroundColor: '#D6EFF2' }}
            >
              <div className="d-flex align-items-center">
                <div style={{ fontSize: "70px", marginBottom: "4px", marginRight: "10px", color: "#4f97a1" }}>
                  <i className={`fas ${v.icon || 'fa-box'}`} />
                </div>
                <h4 style={{ marginTop: "20px" }} className="mb-0 text-dark">
                  {v.title || "Untitled Category"}
                </h4>
              </div>

              {v.bread_crumbs ? (
                <Link
                  to={"sub/" + v.bread_crumbs}
                  className="btn btn-primary"
                  onClick={() => localStorage.setItem("title", v.title || '')}
                  style={{
                    backgroundColor: '#2C99A1',
                    borderColor: '#2C99A1',
                    padding: '6px 14px',
                    borderRadius: '20px',
                    marginTop: '20px',
                  }}
                >
                  See All
                </Link>
              ) : (
                <span
                  className="btn btn-secondary disabled"
                  style={{
                    padding: '6px 14px',
                    borderRadius: '20px',
                    marginTop: '20px',
                    opacity: 0.5,
                  }}
                >
                  See All
                </span>
              )}
            </div>

            {/* 🟩 Child Categories */}
            <div className="row p-4">
              {(Array.isArray(v.child) ? v.child.slice(0, 6) : []).map((item, idx) => (
                <div key={idx} className="col-6 col-md-4 col-lg-2 mb-4">
                  <Link
                    to={
                      v.code === "sub" && item.bread_crumbs
                        ? "sub/" + item.bread_crumbs
                        : item.id
                        ? "product?id=" + item.id + "&s=" + encodeURIComponent(item.name || "")
                        : "#"
                    }
                    onClick={() => localStorage.setItem("title", item.title || '')}
                    className="text-decoration-none"
                  >
                    <div
                      className="custom-card text-center h-100"
                      onMouseEnter={e => e.currentTarget.style.transform = 'scale(1.03)'}
                      onMouseLeave={e => e.currentTarget.style.transform = 'scale(1)'}
                    >
                      <div className="card-img-wrapper">
                        <img
                          src={item.image_path || item.img || "/placeholder.png"}
                          alt={item.title || "Category"}
                          className="card-img-top"
                          loading="lazy"
                          decoding="async"
                          onError={(e) => { e.target.src = "/placeholder.png"; }}
                        />
                      </div>

                      <h6 className="mt-3 my-2 mx-2 text-dark fw-semibold">{item.title || "Subcategory"}</h6>
                      {v.code !== "sub" && (
                        <Button variant="primary" size="sm" className="mt-2">
                          Get Quote
                        </Button>
                      )}
                    </div>
                  </Link>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}

      {/* All Categories CTA */}
      <div className="col-12 text-center mt-4">
        <button
          onClick={() => navigate("/main")}
          style={{
            borderRadius: "20px",
            backgroundColor: 'rgb(69, 172, 179)',
            border: '1px solid rgb(69, 172, 179)',
            color: 'white',
            padding: '10px 20px',
            boxShadow: '0px 0px 17px 6px #ccc'
          }}
        >
          All Categories
          <i className="ti-arrow-right mx-2"></i>
        </button>
      </div>
    </div>
  </div>
</section>



        {/* cat show 1 end */}




        <div className="bg-home9 px-md-4">
          <section className="section-box mt-50">
            <div className="container">
              <div className="row">
                <div className="col-12 px-2 px-md-0 p-0 ">
                <div className="row">
                <div className="col-lg-4 mb-20">
                  <div className="block-sale-1" style={{
            backgroundColor: 'rgba(255, 255, 255, 0.4)',
            borderRadius: '16px',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
            transition: 'transform 0.3s ease',
            cursor: 'pointer',
            minHeight: '220px',
          }}>
                    <div className="row">
                      <div className="col-lg-8 col-sm-8 col-8">

                        <span className="font-sm text-uppercase color-brand-3">
                          Most Viewed
                        </span>
                        <h3 className="mb-10">Apparel & Garments</h3>
                        <a className="btn btn-brand-2 btn-arrow-right" href="sub/apparel-garments">
                          View More
                        </a>
                      </div>
                      <div className="col-lg-4 col-sm-4 col-4">
                        <img src="/assetsss/imgs/page/homepage7/sale1.webp" alt="Ecom" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 mb-20">
                  <div className="block-sale-1 bg-4" style={{
            backgroundColor: 'rgba(255, 255, 255, 0.4)',
            borderRadius: '16px',

            border: '1px solid rgba(255, 255, 255, 0.3)',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
            transition: 'transform 0.3s ease',
            cursor: 'pointer',
            minHeight: '220px',
          }}>
                    <div className="row">
                      <div className="col-lg-8 col-sm-8 col-8">
                        <span className="font-sm text-uppercase color-brand-3">
                          Trending
                        </span>
                        <h3 className="mb-10">Sports & Good Products</h3>
                        <a className="btn btn-brand-2 btn-arrow-right" href="/sub/sports-good-products">
                          View More
                        </a>
                      </div>
                      <div className="col-lg-4 col-sm-4 col-4">
                        <img src="/assetsss/imgs/page/homepage7/sale2.webp" alt="Ecom" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 mb-20">
                  <div className="block-sale-1 bg-10" style={{
            backgroundColor: 'rgba(255, 255, 255, 0.4)',
            borderRadius: '16px',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.2)',
            transition: 'transform 0.3s ease',
            cursor: 'pointer',
            minHeight: '220px',
          }}>
                    <div className="row">
                      <div className="col-lg-8 col-sm-8 col-8">
                        <strong className="font-sm color-danger font-bold text-uppercase">
                          HOT ITEMS
                        </strong>
                        <h3 className="mb-10">Food & Beverages</h3>
                        <a className="btn btn-brand-2 btn-arrow-right" href="/sub/food-beverages">
                          View More
                        </a>
                      </div>
                      <div className="col-lg-4 col-sm-4 col-4">
                        <img src="/assetsss/imgs/page/homepage7/sale3.webp" alt="Ecom" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </div>
              </div>
            </div>
          </section>
        </div>


        {/* <section className="section-box mt-50">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="box-slider-item">
                  <div className="head">
                    <h5>Most Searched Products</h5>
                  </div>
                  <div className="content-slider">
                    <div className="box-swiper">
                      <div className="swiper-container swiper-best-seller">
                        <div className="swiper-wrapper pt-5">
                          <div className="swiper-slide">
                            {searched.slice(0, 4).map((v, i) => (
                              <>
                                <a href={"/product?id=" + v.pid + "&s=" + v.title}>
                                  <div className="card-grid-style-2 card-grid-none-border hover-up">
                                    <div className="image-box">
                                      <a>
                                        <img
                                          src={v.img}
                                          alt="Ecom"
                                        />
                                      </a>
                                    </div>
                                    <div className="info-right">
                                      <span className="font-xs color-gray-500">{v.title}</span>
                                      <br />

                                      <div className="rating">
                                        <img
                                          src="/assetsss/imgs/template/icons/star.svg"
                                          alt="Ecom"
                                        />
                                        <img
                                          src="/assetsss/imgs/template/icons/star.svg"
                                          alt="Ecom"
                                        />
                                        <img
                                          src="/assetsss/imgs/template/icons/star.svg"
                                          alt="Ecom"
                                        />
                                        <img
                                          src="/assetsss/imgs/template/icons/star.svg"
                                          alt="Ecom"
                                        />
                                        <img
                                          src="/assetsss/imgs/template/icons/star.svg"
                                          alt="Ecom"
                                        />
                                        <span className="font-xs color-gray-500">
                                          {" "}
                                          (65)
                                        </span>
                                      </div>
                                      <div className="price-info">
                                        <strong className="font-lg-bold color-brand-3 price-main">
                                          {v.price}
                                        </strong>

                                      </div>
                                    </div>
                                  </div>
                                </a>

                              </>))}
                          </div>



                        </div>
                      </div>
                      <div className="swiper-button-next swiper-button-next-style-2 swiper-button-next-bestseller" />
                      <div className="swiper-button-prev swiper-button-prev-style-2 swiper-button-prev-bestseller" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="box-slider-item">
                  <div className="head">
                    <h5>Featured products</h5>
                  </div>
                  <div className="content-slider">
                    <div className="box-swiper">
                      <div className="swiper-container swiper-featured">
                        <div className="swiper-wrapper pt-5">
                          <div className="swiper-slide">
                            {promotion.slice(0, 4).map((v, i) => (
                              <>
                                <a href={"/product?id=" + v.pid + "&s=" + v.title}>
                                  <div className="card-grid-style-2 card-grid-none-border hover-up">
                                    <div className="image-box">

                                      <img
                                        src={v.img}
                                        alt="Ecom"
                                      />

                                    </div>
                                    <div className="info-right">
                                      <span className="font-xs color-gray-500">{v.title}</span>
                                      <br />

                                      <div className="rating">
                                        <img
                                          src="assetsss/imgs/template/icons/star.svg"
                                          alt="Ecom"
                                        />
                                        <img
                                          src="assetsss/imgs/template/icons/star.svg"
                                          alt="Ecom"
                                        />
                                        <img
                                          src="assetsss/imgs/template/icons/star.svg"
                                          alt="Ecom"
                                        />
                                        <img
                                          src="assetsss/imgs/template/icons/star.svg"
                                          alt="Ecom"
                                        />
                                        <img
                                          src="assetsss/imgs/template/icons/star.svg"
                                          alt="Ecom"
                                        />
                                        <span className="font-xs color-gray-500">
                                          {" "}
                                          (65)
                                        </span>
                                      </div>
                                      <div className="price-info">
                                        <strong className="font-lg-bold color-brand-3 price-main">
                                          {v.price}
                                        </strong>
                                        <span class="color-gray-500 price-line">{v.pro_price}</span>
                                      </div>
                                    </div>
                                  </div>
                                </a>

                              </>))}
                          </div>
                        </div>
                      </div>
                      <div className="swiper-button-next swiper-button-next-style-2 swiper-button-next-featured" />
                      <div className="swiper-button-prev swiper-button-prev-style-2 swiper-button-prev-featured" />
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="box-slider-item">
                  <div className="head">
                    <h5>Trending Products</h5>
                  </div>
                  <div className="content-slider">
                    <div className="box-swiper">
                      <div className="swiper-container swiper-mostviewed">
                        <div className="swiper-wrapper pt-5">
                          <div className="swiper-slide">
                            {trending.slice(0, 4).map((v, i) => (
                              <>
                                <a href={"/product?id=" + v.pid + "&s=" + v.title}>
                                  <div className="card-grid-style-2 card-grid-none-border hover-up">
                                    <div className="image-box">
                                      <span className="label bg-brand-2">-17%</span>

                                      <img
                                        src={v.img}
                                        alt="Ecom"
                                      />

                                    </div>
                                    <div className="info-right">
                                      <span className="font-xs color-gray-500">{v.title}</span>
                                      <br />

                                      <div className="rating">
                                        <img
                                          src="assetsss/imgs/template/icons/star.svg"
                                          alt="Ecom"
                                        />
                                        <img
                                          src="assetsss/imgs/template/icons/star.svg"
                                          alt="Ecom"
                                        />
                                        <img
                                          src="assetsss/imgs/template/icons/star.svg"
                                          alt="Ecom"
                                        />
                                        <img
                                          src="assetsss/imgs/template/icons/star.svg"
                                          alt="Ecom"
                                        />
                                        <img
                                          src="assetsss/imgs/template/icons/star.svg"
                                          alt="Ecom"
                                        />
                                        <span className="font-xs color-gray-500">
                                          {" "}
                                          (65)
                                        </span>
                                      </div>
                                      <div className="price-info">
                                        <strong className="font-lg-bold color-brand-3 price-main">
                                          {v.price}
                                        </strong>

                                      </div>
                                    </div>
                                  </div>
                                </a>
                              </>))}
                          </div>
                        </div>
                      </div>
                      <div className="swiper-button-next swiper-button-next-style-2 swiper-button-next-mostviewed" />
                      <div className="swiper-button-prev swiper-button-prev-style-2 swiper-button-prev-mostviewed" />
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </section> */}

        {/* <div className='bg-home9 lead-seller pt-100'>
          <div className='container overflow-hidden'>
            <div className='row equal-height d-flex justify-content-between gx-3'>
              <div className='col-md-6 bg-home9 card mb-5 card-home-category'>
                <div className="container-fluid m-2">
                  <div className="row">
                    <div className="col-lg-7 d-flex justify-content-between w-100 p-3">
                      <h5 className='ml-3' style={{ color: '#425A8B', fontSize: '20px', fontWeight: 700 }}>Buy Leads</h5>

                      <div className='d-flex'>
                        <a
                          // className="carousel-control-prev"
                          href="#imageCarousel"
                          role="button"
                          data-slide="prev"
                        >
                          <span className='text-dark d-inline-block p-1 border rounded'>
                            <MdKeyboardArrowLeft />
                          </span>
                          <span className="sr-only">Previous</span>
                        </a>
                        <a
                          // className="carousel-control-next"
                          href="#imageCarousel"
                          role="button"
                          data-slide="next"
                        >
                          <span className='text-dark d-inline-block p-1 border rounded ml-1'>
                            <MdOutlineKeyboardArrowRight />
                          </span>
                          <span className="sr-only ">Next</span>
                        </a>
                      </div>
                    </div>
                    <div className="col-lg-5">

                    </div>
                  </div>
                  <div id="imageCarousel" className="carousel slide" data-ride="carousel">
                    <div className="carousel-inner">
                      <div className="carousel-item active">
                        <div className="row">
                          {
                            buyLeads.slice(15, 19).map((v, i) => (<>
                              <div className="col-6 col-sm-3">
                                <img style={{ padding: "2px" }} src={(v.image ?? "http://alahdeen.com/assets/images/logos/logo.png")} className="d-block w-100" alt="Image 1" />
                                <p className="text-center mt-2" style={{ color: '#425A8B', fontSize: '14px', lineHeight: '1.3', fontWeight: 500 }}>{(v.name || "").substring(0, 20)}</p>
                              </div>
                            </>))}
                        </div>
                      </div>
                      <div className="carousel-item">
                        <div className="row">
                          {
                            buyLeads.slice(11, 15).map((v, i) => (<>
                              <div className="col-6 col-sm-3">
                                <img style={{ padding: "2px" }} src={(v.image ?? "http://alahdeen.com/assets/images/logos/logo.png")} className="d-block w-100" alt="Image 1" />
                                <p className="text-center mt-2" style={{ color: '#425A8B', fontSize: '14px', lineHeight: '1.3', fontWeight: 500 }}>{(v.name || "").substring(0, 20)}</p>
                              </div>
                            </>))}
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
              <div className='col-md-6 bg-home9 rounded card mb-5 card-home-category'>
                <div className="container-fluid m-2">
                  <div className="row">
                    <div className="p-3 col-lg-7 w-100 d-flex justify-content-between">
                      <h5 className='ml-3' style={{ color: '#425A8B', fontSize: '20px', fontWeight: 700 }}>Recent Sellers</h5>
                      <div className='d-flex'>
                        <a
                          // className="carousel-control-prev"
                          href="#imageCarousel2"
                          role="button"
                          data-slide="prev"
                        >
                          <span className='text-dark d-inline-block p-1 border rounded'>
                            <MdKeyboardArrowLeft />
                          </span>
                          <span className="sr-only">Previous</span>
                        </a>
                        <a
                          // className="carousel-control-next"
                          href="#imageCarousel2"
                          role="button"
                          data-slide="next"
                        >
                          <span className='text-dark d-inline-block p-1 border rounded ml-1'>
                            <MdOutlineKeyboardArrowRight />
                          </span>
                          <span className="sr-only ">Next</span>
                        </a>
                      </div>
                    </div>
                    <div className="col-lg-5">

                    </div>
                  </div>
                  <div id="imageCarousel2" className="carousel slide" data-ride="carousel">
                    <div className="carousel-inner">
                      <div className="carousel-item active">
                        <div className="row">
                          {
                            vendor.slice(8, 12).map((v, i) => (<>
                              <div className="col-6 col-sm-3">
                                <img style={{ padding: "2px", backgroundColor: 'white' }} src={(v.image ?? "http://alahdeen.com/assets/images/logos/logo.png")} className="d-block w-100" alt="Image 1" />
                                <p className="text-center mt-2" style={{ color: '#425A8B', fontSize: '14px', lineHeight: '1.3', fontWeight: 500 }}>{(v.name || "").substring(0, 20)}</p>
                              </div>
                            </>))}
                        </div>
                      </div>
                      <div className="carousel-item">
                        <div className="row">
                          {
                            vendor.slice(13, 19).map((v, i) => (<>
                              <div className="col-6 col-sm-2">
                                <img style={{ padding: "2px" }} src={(v.cat_image ? v.cat_image : "http://alahdeen.com/assets/images/logos/logo.png")} className="d-block w-100" alt="Image 1" />
                                <p className="text-center mt-2" style={{ color: '#425A8B', fontSize: '14px', lineHeight: '1.3', fontWeight: 500 }}>{(v.name || "").substring(0, 20)}</p>
                              </div>
                            </>))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>







              </div>
            </div>
          </div>
        </div> */}


        {/* <section className="section-box mt-90 mb-50">
          <div className="container">
            <ul className="list-col-5 pl-0">
              <li>
                <div className="item-list">
                  <div className="icon-left">
                    <img src="assetsss/imgs/template/delivery.svg" alt="Ecom" />
                  </div>
                  <div className="info-right">
                    <h5 className="font-lg-bold color-gray-100">45000+ Products</h5>
                  </div>
                </div>
              </li>
              <li>
                <div className="item-list">
                  <div className="icon-left">
                    <img src="assetsss/imgs/template/support.svg" alt="Ecom" />
                  </div>
                  <div className="info-right">
                    <h5 className="font-lg-bold color-gray-100">Support 24/7</h5>
                  </div>
                </div>
              </li>
              <li>
                <div className="item-list">
                  <div className="icon-left">
                    <img src="assetsss/imgs/template/voucher.svg" alt="Ecom" />
                  </div>
                  <div className="info-right">
                    <h5 className="font-lg-bold color-gray-100">Gift voucher</h5>
                  </div>
                </div>
              </li>
              <li>
                <div className="item-list">
                  <div className="icon-left">
                    <img src="assetsss/imgs/template/return.svg" alt="Ecom" />
                  </div>
                  <div className="info-right">
                    <h5 className="font-lg-bold color-gray-100">
                      Live Chatbot
                    </h5>
                  </div>
                </div>
              </li>
              <li>
                <div className="item-list">
                  <div className="icon-left">
                    <img src="assetsss/imgs/template/secure.svg" alt="Ecom" />
                  </div>
                  <div className="info-right">
                    <h5 className="font-lg-bold color-gray-100">Buy Leads</h5>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </section> */}

        {/* <div
          className="modal fade"
          id="ModalQuickview"
          tabIndex={-1}
          aria-hidden="true"
          style={{ display: "none" }}
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content apply-job-form">
              <button
                className="btn-close"
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
              <div className="modal-body p-30">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="gallery-image">
                      <div className="galleries-2">
                        <div className="detail-gallery">
                          <div className="product-image-slider-2">
                            <figure className="border-radius-10">
                              <img
                                src="assetsss/imgs/page/product/img-gallery-1.jpg"
                                alt="product image"
                              />
                            </figure>
                            <figure className="border-radius-10">
                              <img
                                src="assetsss/imgs/page/product/img-gallery-2.jpg"
                                alt="product image"
                              />
                            </figure>
                            <figure className="border-radius-10">
                              <img
                                src="assetsss/imgs/page/product/img-gallery-3.jpg"
                                alt="product image"
                              />
                            </figure>
                            <figure className="border-radius-10">
                              <img
                                src="assetsss/imgs/page/product/img-gallery-4.jpg"
                                alt="product image"
                              />
                            </figure>
                            <figure className="border-radius-10">
                              <img
                                src="assetsss/imgs/page/product/img-gallery-5.jpg"
                                alt="product image"
                              />
                            </figure>
                            <figure className="border-radius-10">
                              <img
                                src="assetsss/imgs/page/product/img-gallery-6.jpg"
                                alt="product image"
                              />
                            </figure>
                            <figure className="border-radius-10">
                              <img
                                src="assetsss/imgs/page/product/img-gallery-7.jpg"
                                alt="product image"
                              />
                            </figure>
                          </div>
                        </div>
                        <div className="slider-nav-thumbnails-2">
                          <div>
                            <div className="item-thumb">
                              <img
                                src="assetsss/imgs/page/product/img-gallery-1.jpg"
                                alt="product image"
                              />
                            </div>
                          </div>
                          <div>
                            <div className="item-thumb">
                              <img
                                src="assetsss/imgs/page/product/img-gallery-2.jpg"
                                alt="product image"
                              />
                            </div>
                          </div>
                          <div>
                            <div className="item-thumb">
                              <img
                                src="assetsss/imgs/page/product/img-gallery-3.jpg"
                                alt="product image"
                              />
                            </div>
                          </div>
                          <div>
                            <div className="item-thumb">
                              <img
                                src="assetsss/imgs/page/product/img-gallery-4.jpg"
                                alt="product image"
                              />
                            </div>
                          </div>
                          <div>
                            <div className="item-thumb">
                              <img
                                src="assetsss/imgs/page/product/img-gallery-5.jpg"
                                alt="product image"
                              />
                            </div>
                          </div>
                          <div>
                            <div className="item-thumb">
                              <img
                                src="assetsss/imgs/page/product/img-gallery-6.jpg"
                                alt="product image"
                              />
                            </div>
                          </div>
                          <div>
                            <div className="item-thumb">
                              <img
                                src="assetsss/imgs/page/product/img-gallery-7.jpg"
                                alt="product image"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="box-tags">
                      <div className="d-inline-block mr-25">
                        <span className="font-sm font-medium color-gray-900">
                          Category:
                        </span>
                        <a className="link" href="#">
                          Smartphones
                        </a>
                      </div>
                      <div className="d-inline-block">
                        <span className="font-sm font-medium color-gray-900">
                          Tags:
                        </span>
                        <a className="link" href="#">
                          Blue
                        </a>
                        ,
                        <a className="link" href="#">
                          Smartphone
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="product-info">
                      <h5 className="mb-15">
                        SAMSUNG Galaxy S22 Ultra, 8K Camera &amp; Video, Brightest
                        Display Screen, S Pen Pro
                      </h5>
                      <div className="info-by">
                        <span className="bytext color-gray-500 font-xs font-medium">
                          by
                        </span>
                        <a
                          className="byAUthor color-gray-900 font-xs font-medium"
                          href="shop-vendor-list.html"
                        >
                          {" "}
                          Ecom Tech
                        </a>
                        <div className="rating d-inline-block">
                          <img src="assetsss/imgs/template/icons/star.svg" alt="Ecom" />
                          <img src="assetsss/imgs/template/icons/star.svg" alt="Ecom" />
                          <img src="assetsss/imgs/template/icons/star.svg" alt="Ecom" />
                          <img src="assetsss/imgs/template/icons/star.svg" alt="Ecom" />
                          <img src="assetsss/imgs/template/icons/star.svg" alt="Ecom" />
                          <span className="font-xs color-gray-500 font-medium">
                            {" "}
                            (65 reviews)
                          </span>
                        </div>
                      </div>
                      <div className="border-bottom pt-10 mb-20" />
                      <div className="box-product-price">
                        <h3 className="color-brand-3 price-main d-inline-block mr-10">
                          $2856.3
                        </h3>
                        <span className="color-gray-500 price-line font-xl line-througt">
                          $3225.6
                        </span>
                      </div>
                      <div className="product-description mt-10 color-gray-900">
                        <ul className="list-dot">
                          <li>8k super steady video</li>
                          <li>Nightography plus portait mode</li>
                          <li>50mp photo resolution plus bright display</li>
                          <li>Adaptive color contrast</li>
                          <li>premium design &amp; craftmanship</li>
                          <li>Long lasting battery plus fast charging</li>
                        </ul>
                      </div>
                      <div className="box-product-color mt-10">
                        <p className="font-sm color-gray-900">
                          Color:
                          <span className="color-brand-2 nameColor">Pink Gold</span>
                        </p>
                        <ul className="list-colors">
                          <li className="disabled">
                            <img
                              src="assetsss/imgs/page/product/img-gallery-1.jpg"
                              alt="Ecom"
                              title="Pink"
                            />
                          </li>
                          <li>
                            <img
                              src="assetsss/imgs/page/product/img-gallery-2.jpg"
                              alt="Ecom"
                              title="Gold"
                            />
                          </li>
                          <li>
                            <img
                              src="assetsss/imgs/page/product/img-gallery-3.jpg"
                              alt="Ecom"
                              title="Pink Gold"
                            />
                          </li>
                          <li>
                            <img
                              src="assetsss/imgs/page/product/img-gallery-4.jpg"
                              alt="Ecom"
                              title="Silver"
                            />
                          </li>
                          <li className="active">
                            <img
                              src="assetsss/imgs/page/product/img-gallery-5.jpg"
                              alt="Ecom"
                              title="Pink Gold"
                            />
                          </li>
                          <li className="disabled">
                            <img
                              src="assetsss/imgs/page/product/img-gallery-6.jpg"
                              alt="Ecom"
                              title="Black"
                            />
                          </li>
                          <li className="disabled">
                            <img
                              src="assetsss/imgs/page/product/img-gallery-7.jpg"
                              alt="Ecom"
                              title="Red"
                            />
                          </li>
                        </ul>
                      </div>
                      <div className="box-product-style-size mt-10">
                        <div className="row">
                          <div className="col-lg-12 mb-10">
                            <p className="font-sm color-gray-900">
                              Style:
                              <span className="color-brand-2 nameStyle">S22</span>
                            </p>
                            <ul className="list-styles">
                              <li className="disabled" title="S22 Ultra">
                                S22 Ultra
                              </li>
                              <li className="active" title="S22">
                                S22
                              </li>
                              <li title="S22 + Standing Cover">
                                S22 + Standing Cover
                              </li>
                            </ul>
                          </div>
                          <div className="col-lg-12 mb-10">
                            <p className="font-sm color-gray-900">
                              Size:
                              <span className="color-brand-2 nameSize">512GB</span>
                            </p>
                            <ul className="list-sizes">
                              <li className="disabled" title="1GB">
                                1GB
                              </li>
                              <li className="active" title="512 GB">
                                512 GB
                              </li>
                              <li title="256 GB">256 GB</li>
                              <li title="128 GB">128 GB</li>
                              <li className="disabled" title="64GB">
                                64GB
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <div className="buy-product mt-5">
                        <p className="font-sm mb-10">Quantity</p>
                        <div className="box-quantity">
                          <div className="input-quantity">
                            <input
                              className="font-xl color-brand-3"
                              type="text"
                              defaultValue={1}
                            />
                            <span className="minus-cart" />
                            <span className="plus-cart" />
                          </div>
                          <div className="button-buy">
                            <a className="btn btn-cart" href="shop-cart.html">
                              Add to cart
                            </a>
                            <a className="btn btn-buy" href="shop-checkout.html">
                              Buy now
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}

        {/* ========================================================= */}

        {/*  */}

      </main>

      <Footer />
    </>
  )
}

export default Home